import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { isChassisType, type ChassisType } from '../utils/chassis-types';

const useSelectedVehicleTypes = (): ChassisType[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.getAll('vehicleType').filter(isChassisType), [searchParameters]);
};

export default useSelectedVehicleTypes;
